import React from 'react';

import './styled.scss';

import icon1 from '../../assets/icons/nosotros/telcel.svg';
import icon2 from '../../assets/icons/nosotros/inbursa.svg';
import icon3 from '../../assets/icons/nosotros/oxxo.svg';
import icon4 from '../../assets/icons/nosotros/scribe.svg';
import icon5 from '../../assets/icons/nosotros/sanfer.svg';
import icon6 from '../../assets/icons/nosotros/bayer.svg';
import icon7 from '../../assets/icons/nosotros/jaloma.svg';
import icon8 from '../../assets/icons/nosotros/zwan.svg';
import icon9 from '../../assets/icons/nosotros/capullo.svg';
import icon10 from '../../assets/icons/nosotros/kraftheinz.svg';
import icon11 from '../../assets/icons/nosotros/clarosports.svg';
import icon12 from '../../assets/icons/nosotros/urrea.svg';
import icon13 from '../../assets/icons/nosotros/inmueblescars.svg';
import icon14 from '../../assets/icons/nosotros/metlife.svg';

import icon15 from '../../assets/icons/nosotros/bankofamerica.svg';
import icon16 from '../../assets/icons/nosotros/capullo01.svg';
import icon17 from '../../assets/icons/nosotros/clarosports01.svg';
import icon18 from '../../assets/icons/nosotros/kone.svg';
import icon19 from '../../assets/icons/nosotros/estafeta.svg';
import icon20 from '../../assets/icons/nosotros/cityexpresshoteles.svg';
import icon21 from '../../assets/icons/nosotros/thyssenkrupp.svg';
import icon22 from '../../assets/icons/nosotros/telesites.svg';
import icon23 from '../../assets/icons/nosotros/vivaaerobus.svg';
import icon24 from '../../assets/icons/nosotros/herdez.svg';
import icon25 from '../../assets/icons/nosotros/pierrefabre.svg';
import icon26 from '../../assets/icons/nosotros/americamovil.svg';
import icon27 from '../../assets/icons/nosotros/cityexpress.svg';

const CarouselOurWork = () => {

    return (
        <>
            <div class="slider">
                <div class="slide-track">
                    <div class="slide">
                        <img src={icon1} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon2} height="100" width="120" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon3} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon4} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon5} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon6} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon7} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon8} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon9} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon10} height="100" width="120" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon11} height="100" width="120" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon12} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon13} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon14} height="100" width="100" alt="icon" />
                    </div>
                </div>
            </div>
            <div class="slider">
                <div class="slide-track">
                    <div class="slide">
                        <img src={icon15} height="100" width="160" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon16} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon17} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon18} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon19} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon20} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon21} height="100" width="140" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon22} height="100" width="120" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon23} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon24} height="100" width="80" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon25} height="100" width="120" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon26} height="100" width="100" alt="icon" />
                    </div>
                    <div class="slide">
                        <img src={icon27} height="100" width="100" alt="icon" />
                    </div>
                </div>
            </div>
        </>
    );
}
 
export default CarouselOurWork;